export default __webpack_public_path__ + "static/media/CyberRisk AssessmentandManagement.df082ca9.png";